import { AsyncPipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, inject, Input, OnInit } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { SafeHtmlPipe } from '../../pipes/safe-html.pipe';

@Component({
  selector: 'app-svg-icon',
  standalone: true,
  imports: [AsyncPipe, SafeHtmlPipe],
  templateUrl: './svg-icon.component.html',
  styleUrl: './svg-icon.component.scss',
})
export class SvgIconComponent implements OnInit {
  http = inject(HttpClient);

  @Input() iconName: string | undefined;
  @Input() width: string | undefined;
  @Input() height: string | undefined;
  svg$: Observable<string> | undefined;

  private static svgCache = new Map<string, string>();

  ngOnInit(): void {
    if (this.iconName) {
      const cachedSvg = SvgIconComponent.svgCache.get(this.iconName);

      if (cachedSvg) {
        // Use cached SVG if available
        this.svg$ = of(
          this.addDimensionsToSvg(cachedSvg, this.width, this.height),
        );
      } else {
        // Fetch SVG if not cached
        this.svg$ = this.http
          .get<string>('assets/icons/' + this.iconName, {
            responseType: 'text' as 'json',
          })
          .pipe(
            map((svgContent: string) => {
              // Cache the fetched SVG
              SvgIconComponent.svgCache.set(this.iconName!, svgContent);
              // Add dimensions to SVG if provided
              return this.addDimensionsToSvg(
                svgContent,
                this.width,
                this.height,
              );
            }),
          );
      }
    }
  }

  addDimensionsToSvg(
    svgContent: string,
    width?: string,
    height?: string,
  ): string {
    if (width || height) {
      return svgContent.replace(/<svg([^>]*)>/i, (_match, attrs) => {
        let cleanAttrs = attrs;
        if (width) {
          cleanAttrs = cleanAttrs.replace(/\s+width="[^"]*"/gi, '');
        }
        if (height) {
          cleanAttrs = cleanAttrs.replace(/\s+height="[^"]*"/gi, '');
        }
        const wAttr = width && width !== 'auto' ? ` width="${width}"` : '';
        const hAttr = height && height !== 'auto' ? ` height="${height}"` : '';
        return `<svg${cleanAttrs}${wAttr}${hAttr}>`;
      });
    }
    return svgContent;
  }
}
